import { useLayoutEffect as m, useEffect as d, createContext as g, useContext as x, useMemo as E } from "react";
var w = globalThis != null && globalThis.document ? m : d;
function C(e, r) {
  return `${e} returned \`undefined\`. Seems you forgot to wrap component within ${r}`;
}
function y(e = {}) {
  const {
    name: r,
    strict: t = !0,
    hookName: i = "useContext",
    providerName: f = "Provider",
    errorMessage: a,
    defaultValue: l
  } = e, o = g(l);
  o.displayName = r;
  function u() {
    var s;
    const c = x(o);
    if (!c && t) {
      const n = new Error(
        a ?? C(i, f)
      );
      throw n.name = "ContextError", (s = Error.captureStackTrace) == null || s.call(Error, n, u), n;
    }
    return c;
  }
  return [o.Provider, u, o];
}
function h(e, r) {
  if (e != null) {
    if (typeof e == "function") {
      e(r);
      return;
    }
    try {
      e.current = r;
    } catch {
      throw new Error(`Cannot assign value '${r}' to ref '${e}'`);
    }
  }
}
function p(...e) {
  return (r) => {
    e.forEach((t) => {
      h(t, r);
    });
  };
}
function $(...e) {
  return E(() => p(...e), e);
}
export {
  $ as a,
  y as c,
  p as m,
  w as u
};
